import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom"; // Using react-router-dom for navigation
import { logout } from "../ReduxToolkit/Reducers/AuthSlice";

const SecureRoute = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated } = useSelector((state: any) => state.auth);
    const [isChecking, setIsChecking] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        // Simulating an initial check, normally we rely on state from Redux
        const checkAuth = () => {
            const token = localStorage.getItem('token');
            if (!token) {
                dispatch(logout());
            }
            setIsChecking(false);
        };

        checkAuth();

        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'token') {
                checkAuth();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [dispatch]);

    useEffect(() => {
        if (!isChecking && !isAuthenticated) {
            dispatch(logout());
        }
    }, [isAuthenticated, isChecking, dispatch]);

    if (isChecking) {
        return null; // Optionally show a loader here
    }

    return isAuthenticated ? (
        <>{children}</> // Render protected content if authenticated
    ) : (
        <Navigate to="/CRMLogin" /> // Redirect to login page if not authenticated
    );
};

export default SecureRoute;
